export const CONTENT_PAGE_SIZE = 12; //This is number of items displayed on content pages

export const CALENDAR_TABS = [
  {
    itemKey: "hae",
    title: "HAE Events",
  },
  {
    itemKey: "multiday",
    title: "Four Day Events",
  },
  {
    itemKey: "inperson",
    title: "In-Person Classes",
  },
  {
    itemKey: "tradeshow",
    title: "Trade Shows",
  },
  {
    itemKey: "virtual",
    title: "Virtual Classes",
  },
];

export const EVENT_MODE_ONLINE = "Online";

export const PRODUCT_DISCOUNT = "Product Discount";
export const FREE_SHIPPING = "Free Shipping";
export const DEAL_STATUS = {
  UPCOMING: "Upcoming",
  ACTIVE: "Active",
  ENDING: "Ending",
  ENDED: "Ended",
};

export const ADMIN_WITH_PLACE_ORDER_PERMISSION = [
  "jmcdaniel@glymedplus.com",
  "jhall@glymedplus.com",
  "jonmcdaniel@gmail.com",
];
export const ASSETS_BASE_URL = process.env.REACT_APP_REGEN_CONTENT;
export const PRODUCT_THUMBNAIL_URL = process.env.REACT_APP_PRODUCT_THUMBNAIL_URL;
export const PRODUCT_STANDARD_URL = process.env.REACT_APP_PRODUCT_STANDARD_URL;
export const PRODUCT_ICON_URL = process.env.REACT_APP_PRODUCT_ICON_URL;
export const VIDEO_THUMBNAIL_URL = `${ASSETS_BASE_URL}/image/product/video-thumbnail-webp`;
export const VIDEO_SRC_URL = `${ASSETS_BASE_URL}/image/product/retail`;

let startDate = new Date(Date.UTC(2023, 5, 13, 7, 0, 0));
let endDate = new Date(Date.UTC(2023, 5, 21, 7, 0, 0));
let today = new Date();

export const RETURN_POLICY = (today >= startDate && today < endDate) ? 'glymed_plus_returns_policies_rebrand.html' : 'glymed_plus_returns_policies.html';

export const PAYMENT_METHODS = {
  CARD: "card",
  APPLE_PAY: "apple_pay",
  GOOGLE_PAY: "google_pay",
  AFTER_PAY: "after_pay",
};

export const RESOURCELINKS = [
  {
    title: "How to Add Your GlyMed+ link to Instagram Bio",
    link: "https://www.dropbox.com/scl/fi/memtf3hdubd8s24f7ayoj/Instructions-for-Adding-REGEN-Link-to-Your-Instagram-Bio.pdf?rlkey=j0gn0whpvq69cq4r6jru0kxyr&e=1&st=w7swztma&dl=0",
    isExternal: true,
  },
  {
    title: "How to Share Your GlyMed+ link in Instagram Stories",
    link: "https://www.dropbox.com/scl/fi/87smf1hc6q4qri0v1b33g/Instructions-for-Sharing-Your-REGEN-Link-on-Instagram.pdf?rlkey=861n2bjkpwuc5yswm5v14h5vz&e=1&st=vggasbdw&dl=0",
    isExternal: true,
  },
  {
    title: "How to Add GIF Stickers to Instagram Stories",
    link: "https://www.dropbox.com/scl/fi/r67hjswjty9evylwou710/Instructions-for-Adding-GIF-Sticker-to-Instagram-Stories.pdf?rlkey=pzqfa8amhwqbbefzerb0o47do&e=1&st=vdts5z8f&dl=0",
    isExternal: true,
  },
  {
    title: "GlyMed+ Retail Toolkit",
    link: "https://www.dropbox.com/scl/fo/e4n6782gs23so14w64j66/ADwTep9Yk_mTBBtZis4VTeA?rlkey=pjlfgaii38o242k37ev6bcppn&e=1&st=toico7n4&dl=0",
    isExternal: true,
  },
  {
    title: "Download Desk Signs with QR Code",
    link: "https://www.dropbox.com/scl/fo/14jobrgouqzh0qc0k8lzn/AJb3DZL2-enlMDXw4t2yRW0?rlkey=6ugcu3ryu1qjevtdfvz8ggc62&e=1&st=tu5pyli7&dl=0",
    isExternal: true,
  },
  {
    title: "Download Web Banners",
    link: "https://www.dropbox.com/scl/fo/gvb1w66jx5z2leobof0od/ALoC8AhFOY9bdasCRwHBgQQ?rlkey=trvoip59eeyim7nxdcyh57plx&e=1&st=jbenp8bw&dl=0",
    isExternal: true,
  },
  {
    title: "Create a Bundle",
    link: "/b2b/my-store/my-recommendations",
    isExternal: false,
  },
  {
    title: "GlyMed+ Rewards Information",
    link: "/reward-referral",
    isExternal: false,
  },
];

export const GLOBAL_COUNTRIES = [
  "AU", "NZ", "UK", "IT", "FR", "JM", "PT", "RE", "MQ", "LC", "SC", "TT",
  "BE", "DE", "DO", "AL", "AS", "AD", "AI", "AG", "AR", "AW", "AT", "AZ",
  "BS", "BH", "BD", "BB", "BZ", "BM", "BO", "BA", "BR", "BN", "BG", "KY",
  "CL", "CO", "CK", "CR", "HR", "CW", "CY", "DK", "DM", "EC", "SV", "FK",
  "FO", "FJ", "FI", "PF", "GI", "GR", "GL", "GD", "GP", "GT", "GG", "GY",
  "HT", "HN", "HU", "IS", "IE", "IL", "JP", "JE", "KI", "KR", "LI", "LU",
  "MV", "MT", "MX", "MC", "ME", "MS", "MA", "NR", "NC", "NI", "NU", "NO",
  "PA", "PG", "PY", "PE", "PH", "MK", "RO", "BL", "KN", "MF", "VC", "WS",
  "SM", "SA", "RS", "SG", "SI", "SB", "ZA", "ES", "LK", "SR", "SE", "CH",
  "TL", "TO", "TN", "TC", "TV", "AE", "UY", "VU", "VG"
];

export const WHITELIST = [
  "/login",
  "/forgot-password",
  "/resetPassword",
  "/webinars",
  "/protocols",
  "/resources",
  "/calendar",
  "/education",
  "/blogs",
  "/charity",
  "/founder",
  "/uac",
];

export const BUNDLE_FORM_CONSTANTS = {
  PLACEHOLDERS: {
    BUNDLE_NAME: "Bundle Name",
    INSTRUCTIONS:
      "Add instructions that your Retail clients will see as a PDF when they open this bundle.",
  },
  MESSAGES: {
    REMOVE_TYPED_INSTRUCTIONS: "Remove typed instructions to upload a PDF",
    REMOVE_PDF_INSTRUCTIONS: "Remove PDF to type instructions manually",
  },
  BUTTON_LABELS: {
    ADD_PRODUCT: "Add Product",
    DELETE_BUNDLE: "Delete Bundle",
    CREATE_BUNDLE: "Create Bundle",
    UPDATE_BUNDLE: "Update Bundle",
    BACK_TO_RECOMMENDATIONS: "Back to recommendations",
  },
  TITLES: {
    EDIT_BUNDLE: "Edit bundle",
    CREATE_BUNDLE: "Create bundle",
    BUNDLE_NAME: "Bundle Name",
    ADD_PRODUCTS: "Add Products to Bundle",
    BUNDLE_INSTRUCTIONS: "Bundle Instructions",
  },
};